var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SelectorPanel',{attrs:{"type":"content","force-full-screen":true}},[(_vm.isActive)?_c('EosIframe',{key:_vm.eosRoute,attrs:{"route":_vm.eosRoute,"height":"100vh"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }